export const MAP_TO_MARKERS_CONFIG = [
    {
        worldMapId: '25cbcd6a-91e6-4dc4-8892-511fa04e9663',
        markers: [
            {
                markerId: '0.6919517815065341',
                action: 'resetZoom' as const
            }
        ]
    },
    {
        worldMapId: '2874985c-30e9-41d6-a999-70f4251f750b',
        markers: [
            {
                markerId: '0.6799752427377139',
                action: 'change' as const
            },
            {
                markerId: '0.35242149506731013',
                action: 'change2' as const
            },
            {
                markerId: '0.20536375027725473',
                action: 'change3' as const
            },
            {
                markerId: '0.3653803481633937',
                action: 'change3' as const
            }
        ]
    }
];
